import React from "react";
import { Spin } from "antd";

interface PageLoaderProps {
  minHeight?: number | string;
}

// Spinner centrado reutilizado en las pantallas mientras cargan sus datos.
const PageLoader: React.FC<PageLoaderProps> = ({ minHeight = 240 }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight,
      width: "100%",
    }}
  >
    <Spin size="large" />
  </div>
);

export default PageLoader;
